// utils/fetchImageAsBlob.js

/**
 * Fetches an image URL, converts it to Blob, and returns a local object URL.
 * @param {string} imageUrl - The remote image URL.
 * @param {RequestInit} [options] - Optional fetch configuration (e.g., credentials).
 * @returns {Promise<string|null>} - The local object URL or null if fetch fails.
 */
export async function imageToBlob(imageUrl, options = {}) {
  try {
    const response = await fetch(imageUrl, options);
    if (!response.ok) {
      console.error(`Failed to fetch ${imageUrl}:`, response.status, response.statusText);
      return null;
    }
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error(`Error fetching or converting ${imageUrl}:`, error);
    return null;
  }
}
